import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faBars } from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const Header = ({
  isScrolled,
  menuOpen,
  setMenuOpen,
  isAuthenticated,
  handleGetStarted,
  loginWithRedirect,
}) => {
  return (
    <header
      className={`fixed w-full top-0 z-50 h-16 transition-all duration-300 ${
        isScrolled
          ? "bg-dark-grey shadow-lg"
          : "bg-dark-grey/95 backdrop-blur-sm"
      }`}
    >
      <div className="container mx-auto px-3 max-w-7xl h-full">
        <div className="flex justify-between items-center h-full">
          <div className="flex items-center">
            <Link
              to="/"
              className="flex items-center group transition-transform duration-300 hover:scale-105"
            >
              <img
                src="/logo-gold.png"
                alt="DayShift Sports MMA"
                className="h-10 md:h-10 object-contain"
              />
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <Button
                as={Link}
                to="/home"
                variant="outline"
                size="md"
                className="bg-white/10 text-white border-white/30 hover:bg-white/20 hover:border-white"
              >
                Dashboard
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => loginWithRedirect()}
                  variant="outline"
                  size="md"
                  className="bg-white/10 text-white border-white/30 hover:bg-white/20 hover:border-white"
                >
                  Login
                </Button>
                <Button onClick={handleGetStarted} variant="primary" size="md">
                  Sign Up
                </Button>
              </>
            )}
          </div>

          <button
            className="md:hidden text-white focus:outline-none bg-white/10 hover:bg-white/20 p-2.5 rounded-lg transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
          >
            <FontAwesomeIcon
              icon={menuOpen ? faTimes : faBars}
              className="w-5 h-5"
            />
          </button>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            menuOpen ? "max-h-[500px] opacity-100 pb-3" : "max-h-0 opacity-0"
          }`}
        >
          <div className="mt-2 rounded-lg bg-dark-grey/95 backdrop-blur-sm shadow-xl border border-white/10">
            {isAuthenticated ? (
              <Link
                to="/home"
                className="flex items-center py-3 px-4 text-white hover:text-gold hover:bg-white/5 transition-colors min-h-[48px]"
                onClick={() => setMenuOpen(false)}
              >
                Dashboard
              </Link>
            ) : (
              <>
                <button
                  onClick={() => {
                    loginWithRedirect();
                    setMenuOpen(false);
                  }}
                  className="flex items-center w-full text-left py-3 px-4 text-white hover:text-gold hover:bg-white/5 transition-colors min-h-[48px]"
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    handleGetStarted();
                    setMenuOpen(false);
                  }}
                  className="flex items-center w-full text-left py-3 px-4 text-white hover:text-gold hover:bg-white/5 transition-colors min-h-[48px]"
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
